import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import PopupLink from '../../../../shared-components/PopupLink/PopupLink';
import { PAGE_NAME } from '../../../config/pageNames';
import DefaultCTABanner from '../DefaultCTABanner/DefaultCTABanner';
import { TERMS_URL, US_NO_INTEREST_OFFER } from '../../../USConstants';

const LOCALE_PREFIX = 'US/components/CTABanner/CTABanner';

export class IncentivesCTABanner extends Component {
    static propTypes = {
        intl: intlShape.isRequired,

        // Passed in props
        incentivesDetails: PropTypes.shape({
            headline_text: PropTypes.string,
            offer_text_1: PropTypes.string,
            offer_text_2: PropTypes.string,
            terms_link: PropTypes.string,
            terms_link_text: PropTypes.string,
            terms_text: PropTypes.string,
        }),
        name: PropTypes.string.isRequired,
        pageName: PropTypes.string,
    };

    render() {
        const { incentivesDetails, intl, name, pageName } = this.props;

        const headlineText = _.get(incentivesDetails, 'headline_text');
        const offerText1 = _.get(incentivesDetails, 'offer_text_1');
        const offerText2 = _.get(incentivesDetails, 'offer_text_2');
        const termsLink = _.get(incentivesDetails, 'terms_link');
        const termsText = _.get(incentivesDetails, 'terms_text', intl.formatMessage({ id: `${LOCALE_PREFIX}.cta-terms-text-incentives-fallback` }));
        const termsLinkText = _.get(incentivesDetails, 'terms_link_text', intl.formatMessage({ id: `${LOCALE_PREFIX}.cta-terms-details-link-incentives-fallback` }));

        let incentiveCreditLineBannerHeaderTextSection;
        if (pageName !== PAGE_NAME.PERSONAL_INFO_PAGE) {
            incentiveCreditLineBannerHeaderTextSection = (
                <div className="body-content">
                    <h1 className="cta-header-incentive">
                        <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-greeting`} />
                    </h1>
                </div>
            );
        }

        return (
            <div className="IncentivesCTABanner show-for-mobile">
                <div className="cta-banner">
                    <div className="credit-line-banner">
                        <div>
                            <div className="money-sign-img cta-header-icon" />
                        </div>
                        <div className="credit-line-banner-details">
                            <div className="cta-headline-incentive">
                                {headlineText} {offerText1} {offerText2}
                            </div>
                            <div className="cta-terms-incentives">
                                {termsText}
                                &nbsp;
                                <PopupLink url={termsLink} name={name}>
                                    {termsLinkText}
                                </PopupLink>
                            </div>
                        </div>
                    </div>
                </div>
                {incentiveCreditLineBannerHeaderTextSection}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    numMonths: _.get(state, 'serverData.financingDetails.term', US_NO_INTEREST_OFFER.TERM)
});

export default connect(mapStateToProps)(injectIntl(IncentivesCTABanner));
